export const FeatureFlags = {
  SMS_MFA_ENABLED: false,
}
